import { useEffect } from 'react';

/**
 * Prevents background scroll while `locked` is true. Compensates for the
 * scrollbar width so layout does not shift when the lock applies.
 * Restores previous inline styles on cleanup.
 */
export function useBodyScrollLock(locked: boolean): void {
    useEffect(() => {
        if (!locked) return;

        const html = document.documentElement;
        const body = document.body;

        const prevBodyOverflow = body.style.overflow;
        const prevHtmlOverflow = html.style.overflow;
        const prevBodyPaddingRight = body.style.paddingRight;

        const scrollbarGap = window.innerWidth - html.clientWidth;

        body.style.overflow = 'hidden';
        html.style.overflow = 'hidden';
        if (scrollbarGap > 0) {
            body.style.paddingRight = `${scrollbarGap}px`;
        }

        return () => {
            body.style.overflow = prevBodyOverflow;
            html.style.overflow = prevHtmlOverflow;
            body.style.paddingRight = prevBodyPaddingRight;
        };
    }, [locked]);
}
